import React from 'react';
import { FunctionColor, BrandColor } from '@lux/core';
import { Checkbox } from '@lux/form-elements';
import { Preset, Text } from '@lux/text';
import { Translate } from '@pegasus/translation';
import * as S from './all-in-category.styles';
export var AllInCategory = function (_a) {
    var categoryName = _a.categoryName, toggleAllInCategory = _a.toggleAllInCategory, isSelected = _a.isSelected;
    return (React.createElement(S.AllInListItem, null,
        React.createElement(S.AllInButton, { onClick: toggleAllInCategory, "aria-pressed": isSelected, "data-testid": "category-filter-small-screen-all-in-category", "data-selected": isSelected },
            React.createElement(Text, { bold: isSelected, preset: Preset.S, color: isSelected ? BrandColor.primary : FunctionColor.function100 },
                React.createElement(Translate, { message: "filters.allIn", params: { category: categoryName } })),
            React.createElement(Checkbox, { readOnly: true, checked: isSelected, tabIndex: -1 }))));
};
